import { render, staticRenderFns } from "./economic.vue?vue&type=template&id=23d74698&scoped=true"
import script from "./economic.vue?vue&type=script&lang=js"
export * from "./economic.vue?vue&type=script&lang=js"
import style0 from "./economic.vue?vue&type=style&index=0&id=23d74698&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d74698",
  null
  
)

export default component.exports